import { required } from "../../base";
import { Customer } from "../../customer";
import { Project } from "../../project";
import { provideReact } from "../../react";
import type { MarketplaceContext } from "./types";

export class ExtensionInstanceContext {
  public readonly value: Project | Customer;
  public readonly type: MarketplaceContext;
  public readonly project?: Project;
  public readonly customer?: Customer;

  public constructor(value: Project | Customer) {
    if (value instanceof Project) {
      this.type = "project";
      this.project = value;
    } else if (value instanceof Customer) {
      this.type = "customer";
      this.customer = value;
    } else {
      throw new Error("Extension context is not supported");
    }
    this.value = value;
  }

  public getCustomer = provideReact(async () => {
    if (this.customer) {
      return this.customer;
    }
    return Project.get(required(this.project, "Project").id).then(
      (p) => p.customer,
    );
  }, [this.project?.id, this.customer?.id]);
}
